/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type SeedVolunteerShiftsMutationVariables = Types.Exact<{
  url: Types.Scalars["String"];
  event_slug: Types.Scalars["String"];
}>;

export type SeedVolunteerShiftsMutation = {
  seedVolunteerShift: Pick<Types.Success, "status">;
};

export const SeedVolunteerShiftsDocument = gql`
  mutation SeedVolunteerShifts($url: String!, $event_slug: String!) {
    seedVolunteerShift(url: $url, event_slug: $event_slug) {
      status
    }
  }
`;

/**
 * __useSeedVolunteerShiftsMutation__
 *
 * To run a mutation, you first call `useSeedVolunteerShiftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedVolunteerShiftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedVolunteerShiftsMutation, { data, loading, error }] = useSeedVolunteerShiftsMutation({
 *   variables: {
 *      url: // value for 'url'
 *      event_slug: // value for 'event_slug'
 *   },
 * });
 */
export function useSeedVolunteerShiftsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SeedVolunteerShiftsMutation,
    SeedVolunteerShiftsMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    SeedVolunteerShiftsMutation,
    SeedVolunteerShiftsMutationVariables
  >(SeedVolunteerShiftsDocument, baseOptions);
}
export type SeedVolunteerShiftsMutationHookResult = ReturnType<
  typeof useSeedVolunteerShiftsMutation
>;
export type SeedVolunteerShiftsMutationResult =
  ApolloReactCommon.MutationResult<SeedVolunteerShiftsMutation>;
export type SeedVolunteerShiftsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SeedVolunteerShiftsMutation,
    SeedVolunteerShiftsMutationVariables
  >;
